import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import { useTranslation } from 'react-i18next';
import p24LogoUrl from '@repo/assets/images/przelewy-24-logo.svg?url';
import ErrorIllustration from '@repo/assets/images/merchant-state/error-permission.webp';
import { useIsMobile } from '@repo/mui-config/hooks';
import { colorPalette } from '@repo/mui-config/color-palette';
export function UnexpectedErrorOccurred() {
    var t = useTranslation().t;
    var isMobile = useIsMobile();
    return (_jsx(Box, { component: "main", sx: {
            minHeight: '100%',
            width: '100%',
            display: 'flex',
        }, children: _jsxs(Paper, { elevation: 0, square: true, sx: {
                width: '100%',
                minHeight: '100%',
                borderRadius: 0,
                boxShadow: 'none',
                backgroundColor: colorPalette.white,
                display: 'grid',
                gridTemplateColumns: isMobile ? '1fr' : '1fr 1fr',
            }, children: [isMobile ? null : (_jsx(Box, { sx: {
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'flex-end',
                        p: '40px',
                    }, children: _jsx(Box, { component: "img", src: ErrorIllustration, alt: "", sx: {
                            display: 'block',
                            width: 'auto',
                            height: 'auto',
                            maxWidth: '92%',
                            maxHeight: '82vh',
                            objectFit: 'contain',
                        } }) })), _jsxs(Box, { sx: {
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'center',
                        textAlign: isMobile ? 'center' : 'left',
                        alignItems: isMobile ? 'center' : 'flex-start',
                        p: isMobile ? '24px' : '48px',
                    }, children: [_jsx(Box, { component: "img", src: p24LogoUrl, alt: "Przelewy24", sx: {
                                display: 'block',
                                height: isMobile ? '40px' : '48px',
                                mb: '28px',
                            } }), _jsx(Typography, { component: "h1", variant: "h2", sx: { mb: '12px', fontWeight: 700, color: colorPalette.ink.main }, children: t('errorBoundary.title') }), _jsx(Typography, { sx: {
                                color: colorPalette.ink.light,
                                fontSize: '16px',
                                lineHeight: '24px',
                            }, children: t('errorBoundary.description') })] })] }) }));
}
